import {
  TypedDocumentNode,
  ApolloClient,
  gql,
  MutationOptions,
} from '@apollo/client'

import {
  GenerateCustomerTokenMutation,
  GenerateCustomerTokenMutationVariables,
} from './generateCustomerToken.generated'

const mutation = gql`
  mutation GenerateCustomerToken($email: String!, $password: String!) {
    generateCustomerToken(email: $email, password: $password) {
      token
    }
  }
` as TypedDocumentNode<
  GenerateCustomerTokenMutation,
  GenerateCustomerTokenMutationVariables
>

export async function generateCustomerToken(
  client: ApolloClient<unknown>,
  email: string,
  password: string,
  options: Omit<
    MutationOptions<
      GenerateCustomerTokenMutation,
      GenerateCustomerTokenMutationVariables
    >,
    'mutation' | 'variables'
  > = {},
) {
  return client.mutate({
    mutation,
    variables: {
      email,
      password,
    },
    fetchPolicy: 'no-cache',
    ...options,
  })
}
